
.SingleDayEvent {
    position: absolute;
}

.SingleDayEvent__dragEnd {
    cursor: ns-resize;
    background: yellowgreen;
    position: absolute;
    inset: auto 0 0;
    height: 5px;
}
